import { useEffect, useRef, useState } from "react";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { INSTITUTION_INVOICE } from "../../credit_invoice/constants/_constant";
import "../css/InvoiceDetails.css";
import moment from "moment";
import { Chat_Icons } from "../../cufront-assets/icons/Icons";
// import { toast } from "react-toastify";
import BillingEmail from "../../credit_invoice/components/BillingEmail";
import CuModal from "../../common_component/component/CuModal";
// import { Modal } from "semantic-ui-react";
// import InvoiceSummary from "../../credit_invoice/components/InvoiceSummary";
// import InputField from "../../common_component/component/InputField";
import { useAtom } from "jotai";
import {
  clinicAtom,
  doctorSettingAtom,
} from "../../_helper/constant/constant-atom";
import { useCreateItem } from "../../_helper/actions/mutation/items";
import PaginationComponent from "../../common_component/component/PaginationComponent";
import CuInput from "../../all-patient/components/CuInput";
import { getImageURL } from "../../_helper/utils/image";
import CuSpinner from "../../common_component/component/CuSpinner";
import { FaDownload } from "react-icons/fa";
import { IoMdSend } from "react-icons/io";
import PrintInvoiceSummary from "./PrintInvoiceSummary";
import { useReactToPrint } from "react-to-print";
import { getCurrentDate, numberToWords } from "../../_helper/utils/utils";
import { BsFillPrinterFill } from "react-icons/bs";

const InvoiceDetails = ({ institutionId }) => {
  const [doctorSettings] = useAtom(doctorSettingAtom);
  const [tableData, setTableData] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [isSend, setIsSend] = useState({
    flag: false,
    summary: [],
  });
  // const [invoiceSummary, setInvoiceSummary] = useState(false);
  const [isDownload, setIsdownload] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageLimit, setPerPageLimit] = useState(10);
  const [dateFilter, setDateFilter] = useState({ startDate: "", endDate: "" });
  const [billNo, setBillNo] = useState(""); // State to store the Bill No
  const printRef = useRef(null); // Create a ref to target PrintInvoiceSummary
  const [totals, setTotals] = useState({
    invoiceTotal: 0,
    recievedPayment: 0,
    pendingPayment: 0,
  });
  const [clinic] = useAtom(clinicAtom);

  const dateFilterQuery =
    dateFilter?.startDate && dateFilter?.endDate
      ? `&date=${moment(dateFilter?.startDate).format("YYYY-MM-DDTHH:mm:ss[Z]")}to${moment(dateFilter?.endDate).format("YYYY-MM-DDTHH:mm:ss[Z]")}`
      : "";

  const queryForInvoice = `?action=getBillingCreditInvoice&frontend=True&clinic_id=${clinic?.id}&institution_customer=${institutionId}&page=${currentPage}&records_number=${perPageLimit}${dateFilterQuery}`;

  const { data: invoiceData } = useItemsFilter(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    queryForInvoice,
    institutionId && clinic?.id ? true : false,
    "invoice"
  );

  // console.log(invoiceData);

  // const getCalculatedPayment = (invoiceData) => {
  //   let recieved_payment = 0;
  //   for (let i of invoiceData) {
  //     recieved_payment += Number(i?.recieved_payment);
  //   }
  //   return { recieved_payment };
  // };

  const isRowSelected = (invoice) => {
    const selectedInvoice = selectedInvoices?.findIndex(
      (invc) => invc?.id === invoice
    );
    if (selectedInvoice > -1) {
      return true;
    } else {
      return false;
    }
  };

  // Set up the printing function with custom page size and styling
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Invoice Summary",
    onBeforeGetContent: () => {
      // Add styles dynamically if needed
      return new Promise((resolve) => {
        const style = document.createElement("style");
        style.innerHTML = `
        @page {
          size: A4; /* Change page size, e.g., A4, Letter */
          margin: 10mm;
        }
        @media print {
          body {
            -webkit-print-color-adjust: exact; /* Ensures colors are printed as seen */
          }
          .print-container {
            font-size: 14px;
            color: #333;
            /* Add any additional styles for print */
          }
        }
      `;
        document.head.appendChild(style);
        resolve();
      });
    },
  });
  const handleCheckboxChange = (event, invoice) => {
    if (event.target.checked) {
      setSelectedInvoices((prev) => [...prev, invoice]); // Add to selectedRows if checked
    } else {
      setSelectedInvoices((prev) =>
        prev?.filter((inc) => inc?.id !== invoice?.id)
      ); // Remove from selectedRows if unchecked
    }
  };

  // const handleSendSummary = (summaryId) => {
  //   // setInvoiceSummary(false);
  //   // setIsSend({ flag: true, summary: [summaryId] });
  // };

  const closeSendModal = () => {
    setIsSend({ flag: false, summary: [] });
  };

  function getMedicineChargesTotal(invoice) {
    let medicineChargesTotal = 0;

    // Loop through the invoice lines
    invoice.invoice_lines.forEach((line) => {
      // Check if the description is "Medicine Charges"
      if (
        (line.sub_lines.length !== 0 &&
          line.description === "Medicine Charges") ||
        line.description == "MEDICINE CHARGE" ||
        line.description == "MEDICINE CHARGES" ||
        line.description == "Medicine Charge"
      ) {
        // Loop through the sub_lines of the medicine charges
        line.sub_lines.forEach((subLine) => {
          // Add the total from each subline to the medicineChargesTotal
          medicineChargesTotal += parseFloat(subLine.total);
        });
      }
    });

    return medicineChargesTotal;
  }

  function getConsultancyChargesTotal(invoice) {
    let consultancyChargesTotal = 0;

    // Loop through the invoice lines
    invoice.invoice_lines.forEach((line) => {
      // console.log("Line", line);
      // If there are no sub_lines, or if the description is not "Medicine Charges"
      if (
        line.sub_lines.length === 0 ||
        line?.description !== "MEDICINE CHARGE"
      ) {
        consultancyChargesTotal += parseFloat(line.total);
      }
    });

    console.log(consultancyChargesTotal);
    return consultancyChargesTotal;
  }

  useEffect(() => {
    if (invoiceData?.data) {
      const tableData = invoiceData?.data?.map((invoice) => {
        const modifiedData = {
          id: invoice?.id,
          slip_no: invoice?.injury_number,
          invoice_number: invoice?.invoice_no,
          patient_name: invoice?.patient_details?.full_name,
          // status: invoice?.status,
          // type: invoice?.bill_type,
          customer: `${invoice?.institution_customer?.billing_address?.building_name},${invoice?.institution_customer?.billing_address?.street_address},${invoice?.institution_customer?.billing_address?.city},${invoice?.institution_customer?.billing_address?.pincode}`,
          diagnosis: invoice?.admission_details?.diagnosis || "",
          treatment: invoice?.admission_details?.treatment || "",
          invoice_date: moment(invoice?.visit_date).format("DD/MM/YY"),
          // recieved_payment: invoice?.received_payment,
          // invoice_pdf: invoice?.pdf_invoice,
          // pending_payment: invoice?.pending_payment,
          consultancy_charges: getConsultancyChargesTotal(invoice)
            ? getConsultancyChargesTotal(invoice)
            : 0,
          medicine_charges: getMedicineChargesTotal(invoice)
            ? getMedicineChargesTotal(invoice)
            : 0,

          invoice_total: Number(
            getConsultancyChargesTotal(invoice) +
              getMedicineChargesTotal(invoice)
          ),
        };
        return modifiedData;
      });
      setTableData([...tableData].reverse());
      setTotals(getTotals(tableData));
    }
  }, [invoiceData]);

  const getTotals = (tableData) => {
    let invoiceTotal = 0;
    let recievedPayment = 0;
    let pendingPayment = 0;

    for (let i of tableData) {
      invoiceTotal += Number(i?.invoice_total);
      recievedPayment += Number(i?.recieved_payment);
      pendingPayment += Number(i?.pending_payment);
    }
    return { invoiceTotal, recievedPayment, pendingPayment };
  };

  const createPdfMutation = useCreateItem(`payments/billing/`);

  const handleDownloadClick = () => {
    const { invoiceTotal, recievedPayment, pendingPayment } =
      getTotals(selectedInvoices);
    const rows = selectedInvoices;
    setIsdownload(true);
  };

  const handleSendClick = () => {
    const { invoiceTotal, recievedPayment, pendingPayment } =
      getTotals(selectedInvoices);
    const rows = selectedInvoices;
    const payload = {
      action: "createPdfInvoice",
      clinic_id: clinic?.id,
      backend: "True",
      pdf_payload: {
        type: "summary",
        pageSize: "A4", // optional
        clinic_id: clinic?.id,
        filename: "summary", // optional
        data: {
          // "columns": [],
          rows: rows,
          headerImg: getImageURL(
            doctorSettings?.header_footer_setup["A4"]?.headerUrl
          ),
          invoiceTotal,
          receivedPayment: recievedPayment,
          pendingPayment,
        },
      },
    };

    createPdfMutation.mutate(payload, {
      onSuccess: (data) => {
        setIsSend({ flag: true, summary: [{ url: data?.url }] });
      },
      onError: () => {},
    });
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedInvoices(tableData);
    } else {
      setSelectedInvoices([]);
    }
  };

  console.log("Selected Invoices", selectedInvoices);

  const totalDataCount = invoiceData?.total_count;
  const totalPages = Math.ceil(totalDataCount / perPageLimit);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleGoToPage = (event) => {
    const page = parseInt(event.target.value);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleGoToPage(event);
    }
  };

  const tableCols = [
    "Slip No.",
    "Date",
    "Patient Name",
    "Diagnosis",
    "Treatment",
    "Consultancy Bill",
    "Medicine Bill",
    "Total",
  ];

  return (
    <div>
      <div className="cu-setup-invoice-details-search-send">
        <div className="cu-setup-invoice-details-left-btns">
          <div className="cu-setup-invoice-details-select-all-btn">
            <input type="checkbox" onChange={handleSelectAll} />
            <label>Select All</label>
          </div>
          {selectedInvoices?.length > 0 &&
            (createPdfMutation.isLoading ? (
              <CuSpinner />
            ) : (
              <div className="flex">
                <div
                  className="cu-setup-invoice-details-send-btn mx-5"
                  onClick={handleDownloadClick}
                >
                  <span>
                    {/* <img
                      src={Chat_Icons.send}
                      alt="send icon"
                      width={"24px"}
                      height={"24px"}
                    /> */}
                    <FaDownload className="text-[20px]" />
                  </span>
                  <span>Download</span>
                </div>
                <div
                  className="cu-setup-invoice-details-send-btn"
                  onClick={handleSendClick}
                >
                  <span>
                    <IoMdSend className="text-[22px]" />
                  </span>
                  <span>Send</span>
                </div>
              </div>
            ))}
        </div>
        <div className="cu-setup-invoice-details-filter">
          <span>
            <CuInput
              label="From"
              type={"date"}
              value={dateFilter?.startDate}
              onChange={(e) =>
                setDateFilter((prev) => ({
                  ...prev,
                  startDate: e.target.value,
                }))
              }
            />
          </span>
          <span>
            <CuInput
              label="To"
              type={"date"}
              value={dateFilter?.endDate}
              onChange={(e) =>
                setDateFilter((prev) => ({
                  ...prev,
                  endDate: e.target.value,
                }))
              }
            />
          </span>
        </div>
      </div>
      <div className="cu-setup-invoice-details">
        <table>
          <thead className="cu-setup-invoice-table-header">
            <tr>
              <th>Select</th>
              {INSTITUTION_INVOICE?.tableCols?.map((col) => (
                <th
                  className={`${col?.label === "Diagnosis" || col?.label === "Treatment" ? "w-[230px]" : ""}`}
                  key={col?.id}
                >
                  {col?.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData?.map((trow, i) => {
              // console.log(tableData);
              return (
                <tr key={i}>
                  <td>
                    <input
                      type="checkbox"
                      checked={isRowSelected(trow?.id)}
                      onChange={(event) => handleCheckboxChange(event, trow)}
                    />
                  </td>
                  {Object.keys(trow)?.map((key, idx) => {
                    if (
                      key !== "customer" &&
                      key !== "id" &&
                      key !== "invoice_number"
                    ) {
                      console.log(key);
                      return <td key={idx}>{trow[key]}</td>;
                    }
                  })}
                </tr>
              );
            })}
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td style={{ fontWeight: "700" }}>Total</td>
              <td style={{ fontWeight: "700" }}>{totals?.invoiceTotal}</td>
              {/* <td style={{ fontWeight: "700" }}>{totals?.recievedPayment}</td>
              <td style={{ fontWeight: "700" }}>{totals?.pendingPayment}</td> */}
            </tr>
          </tbody>
        </table>
      </div>
      {/* {invoiceSummary && (
        <Modal
          open={invoiceSummary}
          onClose={() => setInvoiceSummary(false)}
          closeOnDimmerClick={false}
          closeIcon
        >
          <Modal.Content>
            <InvoiceSummary
              tableData={selectedInvoices}
              handleSendSummary={handleSendSummary}
            />
          </Modal.Content>
        </Modal>
      )} */}
      {isDownload && (
        <CuModal closeModal={setIsdownload} className="w-[50%] items-center">
          {/* Input Field for Bill No */}
          <div className="flex flex-col mb-4">
            <label
              htmlFor="billNo"
              className="font-semibold mb-2 text-gray-700"
            >
              Enter Bill No
            </label>
            <input
              id="billNo"
              type="text"
              value={billNo}
              onChange={(e) => setBillNo(e.target.value)}
              placeholder="Enter Bill Number"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
            />
          </div>

          {/* Download/Print Button */}
          <button
            onClick={handlePrint}
            className="flex float-end mb-4 items-center bg-blue-500 text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-200 ease-in-out shadow-md"
            onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
          >
            <BsFillPrinterFill className="mr-2" />
            Download/Print
          </button>

          {/* Invoice Content */}
          <div ref={printRef} className="print-container">
            <PrintInvoiceSummary
              tableCols={["SR.NO", ...tableCols]}
              setIsSend={() => setIsdownload(false)}
              tableRows={selectedInvoices}
              invoiceTotal={getTotals(selectedInvoices).invoiceTotal}
              amtInWord={numberToWords(
                getTotals(selectedInvoices).invoiceTotal
              )}
              institutionName={`${invoiceData?.data[0]?.institution_customer?.institution_name}, ${invoiceData?.data[0]?.institution_customer?.billing_address?.street_address}, ${
                invoiceData?.data[0]?.institution_customer?.billing_address
                  ?.city
              }, ${
                invoiceData?.data[0]?.institution_customer?.billing_address
                  ?.pincode
              } `}
              panNo={"AACCK63309H"}
              gstNo={"27AACCK6309H1ZK"}
              billDate={getCurrentDate()}
              billNo={billNo || "________"} // Dynamically set Bill No or use placeholder
            />
          </div>
        </CuModal>
      )}
      {isSend?.flag && (
        <CuModal closeModal={closeSendModal}>
          <BillingEmail
            setIsSend={closeSendModal}
            email={invoiceData?.data[0]?.institution_customer?.email_address}
            customerName={
              invoiceData?.data[0]?.institution_customer?.institution_name
            }
            invoicePdf={isSend?.summary}
            subject={`Attention ${invoiceData?.data[0]?.institution_customer?.institution_name} Your summary is ready`}
            title={`Invoices Summary`}
            type={"summary"}
          />
        </CuModal>
      )}
      <div className="mt-3 mb-3 sm:mb-20">
        <PaginationComponent
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          handleKeyPress={handleKeyPress}
          perPageLimit={perPageLimit}
          setPerPageLimit={setPerPageLimit}
        />
      </div>
    </div>
  );
};

export default InvoiceDetails;
